import { module } from 'modujs';
import gsap from 'gsap'
import { shuffle, moveOneLetter, marquee } from '../utils/string'
import { shuffleContainerTexts, shuffleElementTexts } from '../utils/html'

const DURATION = 0.25;

export default class extends module {
    constructor(m) {
        super(m);

        this.shuffleElements = [];
    }

    init() {
        this.onItemEnterBind = this.onItemEnter.bind(this)
        this.onItemLeaveBind = this.onItemLeave.bind(this)

        this.update();
    }

    onItemEnter(e) {
        const $el = e.currentTarget;

        let targets = [];
        if($el.dataset.hoverShuffle == 'children') {
            $el.querySelectorAll('[data-hover-shuffle-child]').forEach(child => {
                targets.push(child)
                child.setAttribute('aria-label', child.innerText)
            })
        } else {
            targets = [$el]
            $el.setAttribute('aria-label', $el.innerText)
        }

        this.tw = gsap.timeline({
            onComplete: () => {
                targets.forEach($target => {
                    $target.innerText = $target.getAttribute('aria-label')
                    $target.removeAttribute('aria-label')
                })
            }
        })

        const shufflePerSecond = 4;
        const shuffleDelay = DURATION/shufflePerSecond

        for(let i = 0; i < shufflePerSecond; i++) {
            for(let $target of targets) {
                this.tw.add(() => {
                    shuffleElementTexts($target, shuffle)
                }, shuffleDelay*i)
            }
        }
    }

    onItemLeave(e) {
        this.tw && this.tw.kill()

        const $el = e.currentTarget;
        let targets = [];
        if($el.dataset.hoverShuffle == 'children') {
            $el.querySelectorAll('[data-hover-shuffle-child]').forEach(child => {
                targets.push(child)
            })
        } else {
            targets = [$el]
        }

        targets.forEach($target => {
            if($target.getAttribute('aria-label')) $target.innerText = $target.getAttribute('aria-label')
            $target.removeAttribute('aria-label')
        })
    }

    reset() {
        this.shuffleElements.forEach(el => {
            el.removeEventListener('mouseenter', this.onItemEnterBind)
            el.removeEventListener('mouseleave', this.onItemLeaveBind)
        })

        this.shuffleElements = [];
    }

    update() {
        this.reset();

        document.querySelectorAll('[data-hover-shuffle]').forEach(el => {
            el.addEventListener('mouseenter', this.onItemEnterBind)
            el.addEventListener('mouseleave', this.onItemLeaveBind)
            this.shuffleElements.push(el);
        })
    }
}
